import React from 'react';

import DesktopNonProSubscriberContent from './DesktopNonProSubscriberContent';
import DesktopProSubscriberContent from './DesktopProSubscriberContent';
import MobileContent from './MobileContent';

export interface StepFinalProps {
  isProSubscriber: boolean;
}

const StepFinal = ({ isProSubscriber }: StepFinalProps) => {
  return (
    <>
      <MobileContent isProSubscriber={isProSubscriber} />
      {isProSubscriber ? <DesktopProSubscriberContent /> : <DesktopNonProSubscriberContent />}
    </>
  );
};

export default StepFinal;
